<!-- 精准教学 -->
<template>
    <div class="precise-teach">
        <div class="precise-teach-top">
            <div class="title">精准教学</div>
            <div class="more" @click="goMore">更多 ></div>
            <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        </div>
        <div class="precise-teach-number">
            <div class="precise-teach-number-item" v-for="(item, index) in numberList" :key="index">
                <div class="name">{{ item.name }}</div>
                <!-- <div class="number">{{ item.number }}</div> -->
                <count-up class="infor-card-count user-created-count" :id-name="`code_${item.name}`"
                    :end-val="item.number" color="#FFFFFF" countSize="16px" :countWeight="700"
                    :isConvert="item.number > 10000 ? 1 : -1" style="height:100%;">
                </count-up>
            </div>
        </div>
        <div class="precise-teach-table">
            <el-row class="top" type="flex">
                <el-col style="text-align: left" :span="8">学校</el-col>
                <el-col style="text-align: center" :span="4">考试数</el-col>
                <el-col style="text-align: center" :span="6">实考人数</el-col>
                <el-col style="text-align: center" :span="6">考试学科数</el-col>
            </el-row>
            <template v-for="item, index in schoolList">
            <el-row class="content" type="flex" v-if="index < 5" :key="item.schoolId">
                <el-col style="text-align: left" :span="8" class="school-name" :title="item.schoolName">{{
                    item.schoolName }}</el-col>
                <el-col style="text-align: center" :span="4">{{ item.examNumber }}</el-col>
                <el-col style="text-align: center" :span="6">{{ item.actualExamNumber }}</el-col>
                <el-col style="text-align: center" :span="6">{{ item.subjectNumber }}</el-col>
            </el-row>
        </template>
        </div>
        <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
        <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
        <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
        <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
    </div>
</template>

<script>
import { getExamStatAPI, getExamSchStatAPI, getAreaStat } from "@/service/api.js"
import CountUp from "@/components/countUp.vue";
export default {
    name: 'precise-teach',
    components: {
        CountUp
    },
    props: {
        //请求参数
        params: {
            type: Object,
            default: () => { }
        },
    },
    data() {
        return {
            numberList: [],
            schoolList: []
        }
    },
    watch: {
        params: {
            deep: true,
            handler(val) {
                // this.getExamStat();
                this.getExamSchStat();
            }
        }
    },
    methods: {
        /**
         * @name 更多
         */
        goMore() {
            window.open(`https://jzjx.syjy.cn/module-examreport/contact?userid=${this.$store.getters.userId}`, "_blank")
        },
        /**
         * @name 获取考试统计
         */
        getExamStat() {
            this.numberList = []
            let params = {
                areaId: this.params.regionId,
                startTime: this.params.startTime,
                endTime: this.params.endTime,
                //空获取全部 '校内考试'获取校内 '联考'获取联考
                type: "校内考试"
            }
            getExamStatAPI(params).then((res) => {
                let numberList = [];
                // numberList.push({
                //     name:'联考数',
                //     number:res.joinExamNum || 0
                // })
                numberList.push({
                    name: '校测数',
                    number: res.schExamNum || 0
                })
                numberList.push({
                    name: '实测人数',
                    number: res.schRealCount || 0
                })
                numberList.push({
                    name: '测试学科',
                    number: res.subCount || 0
                })
                this.$emit('exam-number', res.examNum)
                this.numberList = numberList;
            }).catch((err) => {
                this.$Message.error('考试统计获取失败！');
            })
        },
        /**
         * @name 获取区域学校考试数据统计
         */
        getExamSchStat() {
            // let params = {
            //     regionId:this.params.regionId,
            //     startTime:this.params.startTime,
            //     endTime:this.params.endTime,
            //     limit:5,
            //     //空获取全部 '校内考试'获取校内 '联考'获取联考
            //     type:"校内考试"
            // }
            // getExamSchStatAPI(params).then((res)=>{
            //     this.schoolList = res.map((item)=>{
            //         return {
            //             schoolId:item.schId,
            //             schoolName:item.schName,
            //             examNumber:item.examCount,
            //             actualExamNumber:item.totalNum,
            //             subjectNumber:item.subCount
            //         }
            //     })
            // }).catch((err)=>{
            //     this.$Message.error('区域学校考试数据统计获取失败！');
            // })
            let params = {
                // regionId:this.params.regionId,
                startTime: this.params.startTime,
                endTime: this.params.endTime,
                limit: 5,
                //空获取全部 '校内考试'获取校内 '联考'获取联考
                type: "校内考试"
            }
            getAreaStat(params).then((res) => {
                let schExamNum = 0, schRealCount = 0, subCount = 0;
                this.schoolList = res.schList.map((item) => {
                    schExamNum += item.examNum;
                    schRealCount += item.totalNum;
                    subCount += item.subjectNum;
                    return {
                        schoolId: item.schId,
                        schoolName: item.schName,
                        examNumber: item.examNum,
                        actualExamNumber: item.totalNum,
                        subjectNumber: item.subjectNum
                    }
                })

                let numberList = [];
                numberList.push({
                    name: '校测数',
                    number: schExamNum || 0
                })
                numberList.push({
                    name: '实测人数',
                    number: schRealCount || 0
                })
                numberList.push({
                    name: '测试学科',
                    number: subCount || 0
                })
                this.$emit('exam-number', res.examNum)
                this.numberList = numberList;
            }).catch((err) => {
                this.$Message.error('区域学校考试数据统计获取失败！');
            })
        }
    },
    mounted() {
        //获取考试统计
        // this.getExamStat();
        //获取区域学校考试数据统计
        this.getExamSchStat();
    },
}
</script>

<style lang="scss" scoped>
.precise-teach {
    width: 100%;
    height: 290px;
    padding: 0 15px;
    border: 1px solid #053882;
    background: rgba(6, 17, 52, 0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;

    .precise-teach-top {
        position: relative;
        text-align: center;
        margin-bottom: 15px;

        .title {
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }

        .more {
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }

        .title-bg {
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .precise-teach-number {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 20px;

        .precise-teach-number-item {
            display: flex;
            align-items: center;

            .name {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                margin-right: 5px;
            }

            .number {
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
    }

    .precise-teach-table {
        .top {
            background-color: rgba(16, 34, 67, 0.5);
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #708ACC;
        }

        .content {
            background-color: rgba(16, 34, 67, 0.5);
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #A1B6EB;

            .school-name {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .top-left {
        position: absolute;
        top: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }

    .top-right {
        position: absolute;
        top: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }

    .left-bottom {
        position: absolute;
        bottom: -1px;
        left: -1px;
        width: 14px;
        height: 14px;
    }

    .right-bottom {
        position: absolute;
        bottom: -1px;
        right: -1px;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss"></style>